import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { ProgressBar, Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  ProgressBar,
  Button,
  React
};